import { AlertColor } from "@mui/material";
import { ISocByPetForReminderCardPetDate } from "../services/Standard-of-care/standard-of-care.interface";
import { IPetDataInputForm } from "../services/create-appointment-v2/create-appointment-v2.interface";

export const socStatusMapper = {
  overdue: "Overdue",
  almostDue: "Almost Due",
  current: "Current",
  incomplete: "Incomplete",
};

interface ISOCStatusData {
  label: string;
  color: "default" | "error" | "warning" | "info" | "success" | "primary" | "secondary";
  severity: AlertColor | undefined;
  borderColor: string;
  textColor: string;
  dueText: string;
}

export const getSOCStatusDataMap = (status: string): ISOCStatusData => {
  switch (status) {
  case socStatusMapper.current:
    return {
      label: "On Track",
      color: "success",
      severity: "success",
      borderColor: "transparent",
      textColor: "#262626",
      dueText: "Next Due:",
    };
  case socStatusMapper.almostDue:
    return {
      label: "Coming Due",
      color: "warning",
      severity: "warning",
      borderColor: "transparent",
      textColor: "orange",
      dueText: "Due:",
    };
  case socStatusMapper.overdue:
    return {
      label: "Overdue",
      color: "error",
      severity: "error",
      borderColor: "#ED7857",
      textColor: "red",
      dueText: "Due:" };
  case socStatusMapper.incomplete:
    return {
      label: "InComplete",
      color: "secondary",
      severity: "error",
      borderColor: "transparent",
      textColor: "gray",
      dueText: "Due:" };
  default:
    return {
      label: "N/A",
      color: "warning",
      severity: "error",
      borderColor: "transparent",
      textColor: "gray",
      dueText: "" };
  }
};

export const colorTheme = {
  "Overdue": {
    borderColor: "#F2B6A4",
    bgColor: "#F7E3DC",
    color: "#D35633",
  },
  "Incomplete": {
    borderColor: "#a2a2a2",
    bgColor: "#C8C8C8",
    color: "#696969",
  },
  "Current": {
    borderColor: "#C2EDED",
    bgColor: "#DBE7E7",
    color: "#257B7A",
  },
  "Almost Due": {
    borderColor: "#F7DC8D",
    bgColor: "#F9EED5",
    color: "#AE8305",
  },
  "default": {
    borderColor: "#F7DC8D",
    bgColor: "#F9EED5",
    color: "#AE8305",
  },
};

export const getDefaultSelectedSOCReasons = (
  socDataByPet: ISocByPetForReminderCardPetDate[],
  reasonForVisit: { [key: string]: IPetDataInputForm },
  excludeCategory: string = "none",
) => {
  let reasonsObject: { [key: string]: IPetDataInputForm } = {};

  socDataByPet.forEach((data) => {
    if (reasonForVisit[data.animalId] && reasonForVisit[data.animalId]?.socReasons?.length > 0) {
      reasonsObject[data.animalId] = {
        ...reasonForVisit[data.animalId],
      };
    } else {
      const socReasons: string[] = [];
      const categories = ["vaccination", "dental", "diagnostic"];

      categories.forEach((category) => {
        if (excludeCategory && category === excludeCategory) return;

        if (data.items[category as keyof typeof data.items]) {
          const overDueItems: string[] = [];

          data.items[category as keyof typeof data.items].forEach((item) => {
            if (item.status === socStatusMapper.overdue || item.status === socStatusMapper.almostDue) {
              overDueItems.push(item.name);
            }
          });
          if (overDueItems.length) {
            socReasons.push(`${category}:${overDueItems.join(",")}`);
          }
        }
      });

      reasonsObject[data.animalId] = {
        ...reasonForVisit[data.animalId],
        socReasons,
      };
    }
  });

  reasonsObject={ ...reasonForVisit, ...reasonsObject };

  return reasonsObject;
};
